/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_Cardbody1Inputs */

const id_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apakah Anda penggemar berat Star Wars atau pendatang baru, game ini menawarkan kesenangan tanpa akhir untuk semua orang.`)
};

const ms_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sama ada anda peminat tegar Star Wars atau pendatang baharu, permainan ini menawarkan keseronokan tanpa had untuk semua orang.`)
};

const da_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uanset om du er en dedikeret Star Wars-fan eller nybegynder, tilbyder dette spil uendelig sjov for alle.`)
};

const de_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egal, ob Sie ein eingefleischter Star Wars-Fan oder ein Neuling sind, dieses Spiel bietet endlosen Spaß für alle.`)
};

const en_us2_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whether you're a die-hard Star Wars fan or a newcomer, this game offers endless fun for everyone.`)
};

const es_es2_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya seas un fan acérrimo de Star Wars o un recién llegado, este juego ofrece diversión infinita para todos.`)
};

const es_mx2_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya seas un fan acérrimo de Star Wars o un recién llegado, este juego ofrece diversión infinita para todos.`)
};

const fil_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kung ikaw ay isang matapat na tagahanga ng Star Wars o isang baguhan, ang larong ito ay nag-aalok ng walang katapusang kasiyahan para sa lahat.`)
};

const fr_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que vous soyez un fan inconditionnel de Star Wars ou un nouveau venu, ce jeu offre un divertissement infini pour tous.`)
};

const it_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che tu sia un fan accanito di Star Wars o un nuovo arrivato, questo gioco offre infinito divertimento per tutti.`)
};

const hu_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akár megrögzött Star Wars rajongó vagy, akár újonc, ez a játék végtelen szórakozást kínál mindenkinek.`)
};

const nl_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Of je nu een doorgewinterde Star Wars-fan bent of een nieuwkomer, deze game biedt eindeloos plezier voor iedereen.`)
};

const no_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enten du er en ihuga Star Wars-fan eller nybegynner, tilbyr dette spillet uendelig moro for alle.`)
};

const pl_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niezależnie od tego, czy jesteś zagorzałym fanem Gwiezdnych Wojen, czy nowicjuszem, ta gra oferuje niekończącą się zabawę dla każdego.`)
};

const pt_br2_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quer você seja um fã obstinado de Star Wars ou um novato, este jogo oferece diversão sem fim para todos.`)
};

const pt_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quer seja um fã dedicado de Star Wars ou um recém-chegado, este jogo oferece diversão infinita para todos.`)
};

const ro_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fie că ești un fan înrăit Star Wars sau un începător, acest joc oferă distracție nesfârșită pentru toată lumea.`)
};

const fi_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olitpa sitten intohimoinen Star Wars -fani tai uusi tulokas, tämä peli tarjoaa loputonta hauskaa kaikille.`)
};

const sv_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oavsett om du är ett inbitet Star Wars-fan eller nykomling, erbjuder detta spelet oändligt roligt för alla.`)
};

const vi_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dù bạn là người hâm mộ Star Wars cuồng nhiệt hay người mới, game này mang đến niềm vui bất tận cho mọi người.`)
};

const tr_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İster tutkulu bir Star Wars hayranı olun ister yeni başlayan biri, bu oyun herkes için sonsuz eğlence sunar.`)
};

const cs_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ať už jste zarytý fanoušek Star Wars nebo nováček, tato hra nabízí nekonečnou zábavu pro každého.`)
};

const bg_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Независимо дали сте запален фен на Star Wars или новодошъл, тази игра предлага безкрайно забавление за всеки.`)
};

const ru_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Будь вы заядлым фанатом Star Wars или новичком, эта игра подарит бесконечное удовольствие каждому.`)
};

const uk_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чи ви затятий фанат Star Wars, чи новачок, ця гра пропонує безмежну радість для всіх.`)
};

const ar_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سواء كنت من محبي Star Wars المتعصبين أو وافدًا جديدًا، هذه اللعبة تقدم متعة لا نهاية لها للجميع.`)
};

const hi_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह गेम सभी के लिए अंतहीन मज़ा प्रदान करता है।`)
};

const th_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่ว่าคุณจะเป็นแฟนตัวยงของ Star Wars หรือมือใหม่ เกมนี้มอบความสนุกไม่รู้จบสำหรับทุกคน`)
};

const ja_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`熱狂的な Star Wars ファンでも初心者でも、このゲームは誰にでも無限の楽しさを提供します。`)
};

const zh_cn2_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无论您是星球大战的忠实粉丝还是新手，这款游戏都能为您带来无限乐趣。`)
};

const zh_hant1_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無論您是星際大戰的忠實粉絲還是新手，這款遊戲都能為您帶來無限樂趣。`)
};

const ko_misc_posts_cardbody1 = /** @type {(inputs: Misc_Posts_Cardbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`열렬한 스타워즈 팬이든 새로 오신 분이든, 이 게임은 모두에게 끝없는 재미를 제공합니다.`)
};

/**
* | output |
* | --- |
* | "Whether you're a die-hard Star Wars fan or a newcomer, this game offers endless fun for everyone." |
*
* @param {Misc_Posts_Cardbody1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_cardbody1 = /** @type {((inputs?: Misc_Posts_Cardbody1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Cardbody1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_cardbody1(inputs)
	if (locale === "ms") return ms_misc_posts_cardbody1(inputs)
	if (locale === "da") return da_misc_posts_cardbody1(inputs)
	if (locale === "de") return de_misc_posts_cardbody1(inputs)
	if (locale === "en-US") return en_us2_misc_posts_cardbody1(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_cardbody1(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_cardbody1(inputs)
	if (locale === "fil") return fil_misc_posts_cardbody1(inputs)
	if (locale === "fr") return fr_misc_posts_cardbody1(inputs)
	if (locale === "it") return it_misc_posts_cardbody1(inputs)
	if (locale === "hu") return hu_misc_posts_cardbody1(inputs)
	if (locale === "nl") return nl_misc_posts_cardbody1(inputs)
	if (locale === "no") return no_misc_posts_cardbody1(inputs)
	if (locale === "pl") return pl_misc_posts_cardbody1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_cardbody1(inputs)
	if (locale === "pt") return pt_misc_posts_cardbody1(inputs)
	if (locale === "ro") return ro_misc_posts_cardbody1(inputs)
	if (locale === "fi") return fi_misc_posts_cardbody1(inputs)
	if (locale === "sv") return sv_misc_posts_cardbody1(inputs)
	if (locale === "vi") return vi_misc_posts_cardbody1(inputs)
	if (locale === "tr") return tr_misc_posts_cardbody1(inputs)
	if (locale === "cs") return cs_misc_posts_cardbody1(inputs)
	if (locale === "bg") return bg_misc_posts_cardbody1(inputs)
	if (locale === "ru") return ru_misc_posts_cardbody1(inputs)
	if (locale === "uk") return uk_misc_posts_cardbody1(inputs)
	if (locale === "ar") return ar_misc_posts_cardbody1(inputs)
	if (locale === "hi") return hi_misc_posts_cardbody1(inputs)
	if (locale === "th") return th_misc_posts_cardbody1(inputs)
	if (locale === "ja") return ja_misc_posts_cardbody1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_cardbody1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_cardbody1(inputs)
	return ko_misc_posts_cardbody1(inputs)
});
export { misc_posts_cardbody1 as "misc.posts.cardBody" }